import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getBlogCategoriesList = async (data) => {
    return decryptData(
        await axios.get(
            `/block-categories-list?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const getParentBlocks = async (data) => {
    return decryptData(
        await axios.get(
            `/parent-blocks?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const addBlogcategory = async (data) => {
    return decryptData(
        await axios.post(`/block-categories-add`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};
export const UpdateBlogcategory = async (data) => {
    return decryptData(
        await axios.post(`/block-categories-update`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};


export const StatusUpdateBlogcategory = async (data) => {
    return decryptData(
        await axios.post(`/block-categories-status`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const getBlogCategories = async (data) => {
    return decryptData(
        await axios.get(
            `/get-block-categories?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const getPostList = async (data) => {
    return decryptData(
        await axios.get(
            `/get-post-list?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const getPostbyId = async (data) => {
    return decryptData(
        await axios.get(
            `/get-post-by-id?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const addPost = async (data) => {
  return decryptData(
    await axios.post(`/add-post`, data, setMultiPartHeader())
  );
};

export const updatePost = async (data) => {
  return decryptData(
    await axios.post(`/update-post`, data, setMultiPartHeader())
  );
};

export const updateDisplayWebsiteStatus = async (data) => {
  return decryptData(
    await axios.get(
      `/change-display-website-status?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const updateAudioVisibleStatus = async (data) => {
  return decryptData(
    await axios.get(
      `/change-audio-visible-status?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const updatePostStatus = async (data) => {
    return decryptData(
        await axios.post(`/update-post-status`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const updateTopDisplay = async (data) => {
    return decryptData(
        await axios.post(`/update-top-display`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};

export const updatePostDisplayorder = async (data) => {
    return decryptData(
        await axios.get(
            `/edit-post-display-order?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const getPostCommentsList = async (data) => {
    return decryptData(
        await axios.get(
            `/get-post-comments?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};
export const getUnApprovedPostCommentsList = async (data) => {
    return decryptData(
        await axios.get(
            `/get-unapproved-post-comments?reqData=${encryptData({
                ...data,
                access_token: isLoggedIn(),
            })}`
        )
    );
};

export const updatePostCommentStatus = async (data) => {
    return decryptData(
        await axios.post(`/update-comment-status`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};
export const updatePostCommentReplyStatus = async (data) => {
    return decryptData(
        await axios.post(`/update-comment-reply-status`, {
            reqData: encryptData({
                ...data,
                access_token: isLoggedIn(),
            }),
        })
    );
};
export const deletePost = async (data) => {
  return decryptData(
    await axios.post(`/delete-post`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};